<template>
  <section>
    <section
      :data-background-image="gifUrl"
      data-background-opacity="0.21"
      :data-background-size="backgroundSize"
      id="scorecardSlide"
      v-for="(card, cardLabel) in value"
      :key="'card-' + cardLabel"
      data-autoslide="3000"
    >
      <div
        class="sl-block"
        data-block-type="text"
        style="width: 900px; left: 29px; top: 84px; height: auto"
      >
        <div
          class="sl-block-content"
          data-placeholder-tag="h3"
          data-placeholder-text="Title Text"
          style="text-align: left; z-index: 10; padding-bottom: 50px"
          dir="ui"
        >
          <h2 style="text-align: center; margin-bottom: 0px; font-family: Poppins">
            {{ card[0].hardware_product_label }}
          </h2>
          <h3 style="text-align: center; margin-bottom: 0px; font-family: Poppins">
            {{ card[0].hardware_property_category_label }}
          </h3>
          <!--
          <h4 style="text-align: center" v-if="card[0].datatype == 'Image'">
            {{ card[0].label }}
          </h4>
          -->
        </div>
      </div>

      <div
        class="sl-block"
        data-block-type="table"
        style="
          height: auto;
          min-width: 120px;
          width: 100%;
          left: 29px;
          top: 175.5px;
          min-height: 450px;
          display: flex;
          justify-content: center;
        "
      >
        <div
          v-if="card[0].datatype == 'Image'"
          style="
            width: 100%;
            height: 400px;
            background-size: contain;
            background-position: center center;
          "
          v-bind:style="{ backgroundImage: 'url(' + card[0].stringvalue + ')' }"
        ></div>
        <div v-else>
          <table style="min-width: 60%">
            <tr v-for="spec in card" :key="spec.label">
              <td style="border-bottom: none">
                {{ spec.label }}
              </td>
              <td style="align: right; border-bottom: none">
                {{ spec.stringvalue }}{{ spec.numbervalue }}
              </td>
              <td style="border-bottom: none">{{ spec.unitOfMeasure }}</td>
            </tr>
          </table>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import Scorecard from "@/mixins/Scorecard.js";

export default {
  name: "",
  props: ["value"],
  components: {},
  beforeMount() {
    this.backgroundSize = "cover";
    if (navigator.userAgent.indexOf("Silk") > 0) {
      this.gifUrl = "/img/presentationbackgrounds/AGR-VFU.gif";
    } else {
      this.gifUrl = "/img/presentationbackgrounds/AGR-VFU.gif";
      // this.backgroundSize = "initial";
    }
  },
  mounted() {},
  data() {
    return {
      gifUrl: null,
      backgroundSize: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    refresh() {},
  },
};
</script>
<style>
#scorecardSlide td {
  font-size: 0.8em;
}
</style>

